/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import styles from './shared-styles';

const TruckBedMedium = ({ height, width, color, className, secondaryColor, ...props }) => (
  <span css={styles} className={className}>
    <svg viewBox="0 0 96 73" height={height} width={width} {...props} xmlns="http://www.w3.org/2000/svg">
      <g fill={color}>
        <g fillRule="nonzero"><path d="M.1 49.7v9.8h26.2v-.3c0-3.3.9-6.6 2.7-9.4L.1 49.7zM94.3 49.7H59.1c1.8 2.8 2.7 6.1 2.7 9.4v.3h32.6c.9 0 1.6-.7 1.6-1.6v-6.5c-.1-.9-.8-1.6-1.7-1.6zM44 41.4c4.7 0 9.2 1.9 12.5 5.2h34.6V20.7H6.4V0H.1v46.5h31.4c3.4-3.3 7.9-5.2 12.5-5.1zm40.2-6.9c0-.8.7-1.4 1.4-1.4H87c.8 0 1.4.7 1.4 1.4v7.9c0 .8-.7 1.4-1.4 1.4h-1.3c-.8 0-1.4-.7-1.4-1.4v-7.9h-.1z" /><circle cx="43.9" cy="59" r="13.7" /></g>
      </g>
    </svg>
  </span>
);

TruckBedMedium.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  secondaryColor: PropTypes.string
};

TruckBedMedium.defaultProps = {
  height: 25,
  width: 25,
  color: 'currentColor',
  className: '',
  secondaryColor: 'currentColor'
};

export default TruckBedMedium;
